<div class="list-page">
  <div class="list-page__table-block">
    <table-cmp
      *ngIf="usersList$ | async as list"
      [isUserList]="true"
        [isSlokaType]="false"
      [table-data]="list"
      [page]="page"
      class="table-block"
    ></table-cmp>
  </div>
  <div class="list-page__pagination-block">
    <pagination-controls
      class="table-paginate"
      (pageChange)="page = $event"
    ></pagination-controls>
  </div>
</div>
